export default function Founders() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-5xl font-bold text-orange-500 mb-4">Our Founders</h2>
          <p className="text-gray-700 text-base">
            Our vision since we started KKHC has been to deliver the best quality service to your loved ones.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="group relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 cursor-pointer">
            <div className="relative h-[500px] w-full overflow-hidden">
              <img
                src="https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/864749d7f3f4fd54b87e9d6518cbd3c8.jpeg"
                alt="Yana - Owner"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-black/60"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
              <div className="inline-block bg-orange-500 text-white px-6 py-2 rounded-full text-sm font-bold mb-3">
                YANA "OWNER"
              </div>
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg mb-4">
                <span className="text-2xl font-bold text-[#5C4F8A]">K</span>
              </div>
            </div>
          </div>

          <div className="group relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 cursor-pointer">
            <div className="relative h-[500px] w-full overflow-hidden">
              <img
                src="https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/a2ac5467db4c4ebdbf57ba8cc233d1ac.jpeg"
                alt="Yasmeen - Owner"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-black/60"></div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
              <div className="inline-block bg-orange-500 text-white px-6 py-2 rounded-full text-sm font-bold mb-3">
                YASMEEN "OWNER"
              </div>
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg mb-4">
                <span className="text-2xl font-bold text-[#5C4F8A]">K</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
